import React from "react";
import { about } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow={about.eyebrow} heading={about.heading} highlight="coordination model" index="10" />
      <Section indexLabel="10.1" bg="panel">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="mono text-[11px] tracking-[0.25em] uppercase grad-text font-semibold mb-4">The purpose</div>
            <h2 className="display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1]">
              Coordination across setup, workflows, <span className="grad-text">connectivity, and visibility.</span>
            </h2>
          </div>
          <p className="lg:col-span-7 text-base md:text-lg text-[#0A0E1A]/80 leading-relaxed">
            {about.main}
          </p>
        </div>
      </Section>
      <Section eyebrow="Supporting blocks" heading="What it is. Why it exists. How it works." highlight="Why it exists" indexLabel="10.2">
        <CardGrid cols={3}>
          {about.blocks.map(([title, body], i) => (
            <FeatureCard key={title} index={String(i + 1).padStart(2, "0")} title={title} body={body} featured={i === 0 || i === 4} />
          ))}
        </CardGrid>
      </Section>
      <CtaBand heading="Let's build coordination together." ctas={about.ctas} />
    </div>
  );
}
